import "./editor.less";
import SceneEditor from "ui/editor/scene-editor/SceneEditor";

document.addEventListener('DOMContentLoaded', () => {
	const url = window.location.href;
	let items = url.match(
		/editor\/([a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12}|[tb]\d+[lr]\d+|l\d+)($|\/|#)/
	);

	if (items) {
		new SceneEditor({
			parent: document.body,
			sceneId: items[1]
		});
	} else {
		new SceneEditor({
			parent: document.body,
			sceneId: 'l0'
		});
	}
});
